import React from 'react'
import style from "./MainProfile.module.css"

const MainProfile = () => {
  return (
    <div className={style.main_profile}>
      <input type="text" />
      <input type="text" />
      <button>Sign in</button>
    </div>
  )
}

export default MainProfile